// import axios from "utils/axios";
import Config from 'config';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { KRAKEN_OHLC } from "../store/actions";

export const getOHLCData = async (rcoin, interval) => {


    let url =
        "https://" +
        Config.takyon_domain +
        "/ohlc?pair=" +
        (rcoin) +
        "&interval=" + 
        interval + 
        "&exchange=alpaca&c_token=0xDEADBEEF";
    console.log( '1. Now Fetching OHLC from ' + url);

    const response = await axios.get(
        url,
        {},
        {
          headers: {
            Accept: "*",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
    );
    return response.data;
};

//DEPRECATED! to be removed
export default function useAlpacaOHLC() {

  const dispatch = useDispatch();

  const fetchAlpacaOHLC = (rcoin, interval) => {

    // TMD console.log( 'FETCH_ALPACA_OHLC --- ' + rcoin);
    getOHLCData(rcoin, interval).then((data) => {
      // TMD console.log({ data });
      dispatch({ type: KRAKEN_OHLC, payload: data});
    });
  };

  return {
    fetchAlpacaOHLC
  };
}
